import { render, staticRenderFns } from "./CompanInfo.vue?vue&type=template&id=6715bb11&scoped=true"
import script from "./CompanInfo.vue?vue&type=script&lang=js"
export * from "./CompanInfo.vue?vue&type=script&lang=js"
import style0 from "./CompanInfo.vue?vue&type=style&index=0&id=6715bb11&prod&lang=less"
import style1 from "./CompanInfo.vue?vue&type=style&index=1&id=6715bb11&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6715bb11",
  null
  
)

export default component.exports